import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForgotPassword } from '../api/useAuth'
import { getErrMsg } from '../api/client'
import Input from '../components/ui/Input'
import toast from 'react-hot-toast'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const { mutate: forgotPassword, isPending } = useForgotPassword()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError('Введите корректный email')
      return
    }
    setError('')
    forgotPassword(
      { email },
      {
        onSuccess: () => setSent(true),
        onError: (err) => {
          toast.error(getErrMsg(err, 'Произошла ошибка'))
        },
      }
    )
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div
        className="w-full max-w-sm rounded-2xl p-8 flex flex-col gap-6 bg-surface border border-line"
      >
        {sent ? (
          <div className="text-center flex flex-col gap-4">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center text-3xl mx-auto"
              style={{ background: 'rgba(240,168,52,0.15)' }}
            >
              ✉️
            </div>
            <div>
              <h1 className="text-xl font-black">Письмо отправлено</h1>
              <p className="text-sm mt-2 text-muted">
                Проверьте почту <span className="font-semibold text-fg">{email}</span> и
                следуйте инструкциям.
              </p>
            </div>
            <Link to="/login" className="text-sm font-semibold transition-colors text-accent">
              Вернуться к входу
            </Link>
          </div>
        ) : (
          <>
            <div className="text-center">
              <h1 className="text-2xl font-black">Восстановление пароля</h1>
              <p className="text-sm mt-1 text-muted">
                Введите email — пришлём ссылку для сброса
              </p>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <Input
                label="Email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={error}
                autoComplete="email"
              />
              <button
                type="submit"
                disabled={isPending}
                className="w-full py-3 rounded-xl font-bold text-sm transition-all disabled:opacity-50 bg-accent text-on-accent hover:opacity-90"
              >
                {isPending ? 'Отправляем...' : 'Отправить письмо'}
              </button>
            </form>

            <p className="text-sm text-center text-muted">
              <Link to="/login" className="font-semibold text-accent">
                Вернуться к входу
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  )
}
